import { BrowserRouter, Routes, Route } from "react-router-dom";


import { Homepage } from "./pages/Home/home-page";
import { Categories } from "./pages/categories/categories";
import { WhishList } from "./pages/wishlist/wishList";
import { Cartpage } from "./pages/cart/cart";
import { DetailsPage } from "./pages/Home/details";
import { WhatsappButton } from "./components/utils/whatsapp-button";
import { LoginPage } from "./pages/account/login";
import { RegistrationPage } from "./pages/account/register";
import { ForgotPassword } from "./pages/account/forgot-password";
import { ResetPassword } from "./pages/account/reset-password";
import { AuthenticationContextProvider } from "./services/authentication/authentication.context";
import { ProtectedRoute } from "./components/layout/protected";
import { AdminPage } from "./pages/account/admin";
import { ProductAddForm } from "./pages/dashboard/add-product";
import { AdminDashboard } from "./pages/dashboard/dashboard";
import { ProductContextProvider } from "./services/products/product.context";
import { OrderPage } from "./pages/cart/order";
import { ProductUpdate } from "./pages/dashboard/update-product";
import { ProductUpdateForm } from "./pages/dashboard/update-page";
import { FooterComponent } from "./components/footer/footer";
import { ScrollToTopButton } from "./components/utils/scrolltoTop";
import { UpdateAccount } from "./pages/account/update-account";

/** paths in french site */
import { Homepage as FrHomepage } from "./fr/pages/Home/home-page";
import { Categories as FrCategories } from "./fr/pages/categories/categories";
import { WhishList as FrWhishList } from "./fr/pages/wishlist/wishList";
import { Cartpage as FrCartpage } from "./fr/pages/cart/cart";
import { DetailsPage as FrDetailsPage } from "./fr/pages/Home/details";
import { LoginPage as FrLoginPage } from "./fr/pages/account/login";
import { RegistrationPage as FrRegistrationPage } from "./fr/pages/account/register";
import { ForgotPassword as FrForgotPassword } from "./fr/pages/account/forgot-password";
import { ResetPassword as FrResetPassword } from "./fr/pages/account/reset-password";
import { ProtectedRoute as FrProtectedRoute } from "./fr/components/layout/protected";
import { AdminPage as FrAdminPage } from "./fr/pages/account/admin";
import { ProductAddForm as FrProductAddForm } from "./fr/pages/dashboard/add-product";
import { AdminDashboard as FrAdminDashboard } from "./fr/pages/dashboard/dashboard";
import { OrderPage as FrOrderPage } from "./fr/pages/cart/order";
import { ProductUpdate as FrProductUpdate } from "./fr/pages/dashboard/update-product";
import { ProductUpdateForm as FrProductUpdateForm } from "./fr/pages/dashboard/update-page";
import { UpdateAccount as FrUpdateAccount } from "./fr/pages/account/update-account";

import "./App.css";
import "./styles/categories.css";
import "./styles/catalogue.css";
import "./styles/details.css";
import "./styles/home.css";
import "./styles/cart.css";
import "./styles/order.css";
import "./styles/admin.css";
import "./styles/forms.css";
import "./styles/dashboard-data.css";
import "./styles/dashboard.css";
import "./styles/footer.css";
import "./styles/cost-filter.css";
import { useState, useEffect } from "react";




function App() {
  return (
    <BrowserRouter>
      <AuthenticationContextProvider>
        <ProductContextProvider>
          <WhatsappButton />
          <ScrollToTopButton />
            <Routes>
              <Route path="/" element={<Homepage />} />
              <Route path="/categories" element={<Categories />} />
              <Route path="/wishlist" element={<WhishList />} />
              <Route path="/cart" element={<Cartpage />} />
              <Route path="/details" element={<DetailsPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegistrationPage />} />
              <Route path="/sendMail" element={<ForgotPassword />} />
              <Route path="/resetpassword" element={<ResetPassword />} />
              <Route path="/checkout" element={<OrderPage />} />
              <Route path="/fr">
                <Route path="" element={<FrHomepage />} />
                <Route path="categories" element={<FrCategories />} />
                <Route path="wishlist" element={<FrWhishList />} />
                <Route path="cart" element={<FrCartpage />} />
                <Route path="details" element={<FrDetailsPage />} />
                <Route path="login" element={<FrLoginPage />} />
                <Route path="register" element={<FrRegistrationPage />} />
                <Route path="sendMail" element={<FrForgotPassword />} />
                <Route path="resetpassword" element={<FrResetPassword />} />
                <Route path="checkout" element={<FrOrderPage />} />
                <Route element={<ProtectedRoute />} >
                  <Route path="admin" element={<FrAdminPage />} />
                  <Route path="addproduct" element={<FrProductAddForm />} />
                  <Route path="dashboard" element={<FrAdminDashboard />} />
                  <Route path="update_delete" element={<FrProductUpdate />} />
                  <Route path="updateproduct" element={<FrProductUpdateForm />} />
                  <Route path="updateaccount" element={<FrUpdateAccount />} />
                </Route>
              </Route>
              <Route element={<ProtectedRoute />} >
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/addproduct" element={<ProductAddForm />} />
                <Route path="/dashboard" element={<AdminDashboard />} />
                <Route path="/update_delete" element={<ProductUpdate />} />
                <Route path="/updateproduct" element={<ProductUpdateForm />} />
                <Route path="/updateaccount" element={<UpdateAccount />} />
              </Route>
            </Routes>
        </ProductContextProvider>
      </AuthenticationContextProvider>
    </BrowserRouter>
  );
}

export default App;
